import { useState, useEffect } from "react";
import { SubActuators } from "utils/slnt-file";
import { getSubActuators, subscribeSubActuators } from "utils/packet-workers";

export const useSubActuators = (): SubActuators => {
    const [ subActuators, setSubActuators ] = useState( getSubActuators );
    useEffect( () => subscribeSubActuators( () => setSubActuators( getSubActuators() ) ), [] );
    return subActuators;
};
